import React, { useState } from 'react';
import { Button, Col, Form, Row } from 'antd';
import { FormBox, InputBox } from '../../../../components/AntdAddons';
import { validations } from '../../../../config/validations/validations';
import { CheckOutlined } from '@ant-design/icons';

import { useDispatch } from 'react-redux';
import { AppDispatch } from '../../../../store/app';
import { checkAesteriskNumber } from '../../../../store/SendMessageSlice';

const CheckForm: React.FC<any> = () => {
  const [form] = Form.useForm();
  const dispatch: AppDispatch = useDispatch();

  const [loading, setLoading] = useState<boolean>(false);
  const [asteriskData, setAsteriskData] = useState<any>();

  const handleSubmit = async (data?: any) => {
    setLoading(true);

    const payload = {
      action: 'asterisk_number',
      number: data?.number ? data?.number : '',
    };

    dispatch(checkAesteriskNumber(payload))
      .then((res: any) => {
        setAsteriskData(res?.data);
        // setInquireListData(res?.data);
        // setListData(res?.data);
        // setTotalData(res?.total_data);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
    // if (data?.message_action === 'Check') {
  };
  // for validation
  const handleChange = () => {
    form
      .validateFields()
      .then(() => {
        // setDisable(false);
      })
      .catch((error: any) => {
        // setDisable(true);
      });
  };

  return (
    <>
      <FormBox
        className='filterForm'
        form={form}
        onFinish={handleSubmit}
        onChange={handleChange}
        validateTrigger={['onBlur', 'onInput']}
        autoComplete='off'>
        <Row gutter={[20, 0]} align={'middle'}>
          <Col xs={24} md={24} lg={12} xxl={12}>
            <InputBox.Text
              label='Asterisk Number'
              name={'number'}
              tooltip='A single number to request to be ported.
                    Must be in a domestic form (e.g. 12223555 or *3555)'
              required
              rules={[
                validations.required.text('Asterisk Number'),
                validations.pattern.numericWithSecial,
                // validations.pattern.whitespace,
              ]}
            />
          </Col>
          <Col xs={12} md={12} lg={6} xl={5}>
            {/* <Form.Item label=' '> */}
            <Button type='primary' htmlType='submit' loading={loading}>
              <CheckOutlined /> Check Number
            </Button>
            {/* </Form.Item> */}
          </Col>
          <Col xs={12} md={12} lg={6} xl={4}>
            {/* <Form.Item label=' '> */}
            <Button
              type='default'
              htmlType='reset'
              onClick={() => {
                setAsteriskData(null);
              }}>
              Clear
            </Button>
            {/* </Form.Item> */}
          </Col>
        </Row>
      </FormBox>

      {asteriskData ? (
        <ul className='asteriskData'>
          <li>
            <div className='lable'>Asterisk Number:</div>{' '}
            <div>{asteriskData?.asterisk_number}</div>
          </li>
          <li>
            <div className='lable'>Full Asterisk Number:</div>{' '}
            <div>{asteriskData?.full_asterisk_number}</div>
          </li>
          <li>
            <div className='lable'>Number:</div>{' '}
            <div>{asteriskData?.number}</div>
          </li>
          <li>
            <div className='lable'>Provider Code:</div>{' '}
            <div>{asteriskData?.provider_code}</div>
          </li>
          <li>
            <div className='lable'>Provider ID:</div>{' '}
            <div>{asteriskData?.provider_id}</div>
          </li>
          <li>
            <div className='lable'>Provider Name:</div>{' '}
            <div>{asteriskData?.provider_name}</div>
          </li>
          <li>
            <div className='lable'>Shadow Number:</div>{' '}
            <div>{asteriskData?.shadow_number}</div>
          </li>
        </ul>
      ) : null}
    </>
  );
};

export default CheckForm;
